import React from 'react';
import { Typography } from '@mui/material';
import { useStyles } from './styles';

export const Title: React.FC = (): JSX.Element => {
  const classes = useStyles();

  return <Typography className={classes.sectionTitle}>Benefit Investigation</Typography>;
};
